<template>
  <v-card class="py-3" >
<!--
    <span class="title px-3 my-3">サンプル採取マイ機器一覧</span>
-->
    <v-row dense>
      <v-col cols="12">
        <div class="px-3">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="マイ機器を検索"
          filled
          dense
        ></v-text-field>
        </div>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="machines"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :search="search"
          :sort-by="['Name']"
          :sort-desc="[false]"
          :loading="loading"
          class="elevation-1"
          loading-text="読込中"
          no-data-text="データがありません。"                    
          no-results-text="検索条件に該当するデータがありません。"                  
          hide-default-footer
          @page-count="pageCount = $event"
          id="row-pointer"
        >
          <!-- @click:row="(data) => { $router.push(`/mymachine?id=${data.id}`) }" -->
          <template v-slot:[`item.LatestOrderAt`]="{ item }">
            <span v-show="item.LatestOrderAt"> {{ item.LatestOrderAt | moment('YYYY[/]MM[/]DD') }} </span>
            <span v-show="!item.LatestOrderAt"> なし </span>
          </template>
          <template v-slot:[`item.OperatingTime`]="{ item }">
            <span> {{ item.OperatingTime }} {{ item.OperatingTimeUnitText }} </span>
          </template>
          <template v-slot:[`item.id`]="{ item }">
            <v-tooltip left color="grey darken-2">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-show="item.isAccept == '1'"
                  v-on="on"
                  fab
                  x-small
                  elevation="1"
                  color="amber"
                  :to="{ path: 'sampling/', query: { id: item.id }}"
                  class="mx-2
                  caption"
                  id="sample_btn">
                  <v-icon small>mdi-cup-water</v-icon>
                </v-btn>
              </template>
              <span>クリックすると、分析サンプルの採取登録画面が開きます</span>
            </v-tooltip>

            <v-tooltip left color="grey darken-2">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-show="item.isAccept == '0'"
                  v-on="on"
                  readonly
                  fab
                  x-small
                  elevation="1"
                  color="gray"
                  class="mx-2
                  caption"
                  id="sample_btn">
                  <v-icon v-on="on" small>mdi-cup-water</v-icon>
                </v-btn>
              </template>
              <span>危険物が含まれるためマイ機器（オイル）のため個別にご相談ください</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="10" md='10' sm='12'>
        <v-pagination
          v-model="page"
          :total-visible="totalVisible"
          :length="pageCount"
          color="amber black--text"
          light 
          circle
        >
        </v-pagination>
      </v-col>
      <v-col cols="2"  lg="2"  md='4' sm='4' xs="2" dense>
        <v-select
          :value="itemsPerPage"
          :items = "itemsPerPageList"
          label="1ページの行数"
          @input="itemsPerPage = Number($event)"
        ></v-select>
      </v-col>
    </v-row>
  </v-card >    
</template>

<script>
import { machinesEvent } from "../utils/eventbus.js"
import { fetchAllMachineByOffice } from '../utils/utils'

export default {
  name: 'MyMachineListComp',
  data() {
    return {
      search: '',
      page: 1,
      pageCount: 0,
      totalVisible: 7,
      itemsPerPage: 5,
      itemsPerPageList: [ 5,10,30 ],

      LatestOrderAt: "",
      loading: false,      
      headers: [
        {
          text: 'マイ機器名',
          align: 'start',
          value: 'Name',
          class: "grey darken-2 white--text",
          width: '35%'
        },
        {
          text: 'マイ機器ＩＤ',
          value: 'CustomerMachineID',
          class: "grey darken-2 white--text"

        },
        {
          text: '前回検査日',
          value: 'LatestOrderAt',
          class: "grey darken-2 white--text"

        },
        {
          text: '稼働時間／距離',
          value: 'OperatingTime',
          class: "grey darken-2 white--text"

        },
        {
        text: '採取',
        value: 'id',
        class: "grey darken-2 white--text"
        },
      ],
      machines: [],
    }
  },
  mounted: async function () {
    //  全カラムの一覧を取る場合はこの1行でOK
    //  let machines = await API.graphql(graphqlOperation(listMachines, {limit: 100, items: "Name,  CustomerMachineID, OperatingTime, OperatingTimeUnit"}))
    //  取得するカラムを指定する場合はこのように書く。
    this.loading = true
      this.machines = await fetchAllMachineByOffice(this.$store.state.operatingOffice.OfficeID)
        console.log(this.machines);
        machinesEvent.$emit('machinesData', this.machines)
      this.loading = false
      },
  computed : {
  }
}
</script>
<style lang="css" scoped>
/* #row-pointer >>> tbody tr :hover {
  cursor: pointer;
} */
</style>